<template>
  <div>
    <!-- <pre>
    {{subpasses}}
    {{days}}
    {{nights}}
    </pre>-->
    <input
      type="checkbox"
      id="includeOvernight"
      @change="includeOverNightChange"
      v-model="includeOvernight"
    />
    Include Overnight Passes
    <div class="table-responsive" v-if="numberOfDays > 0">
      <table
        class="table table-day-night-list table-sm"
        aria-label="Day and night passes to purchase"
      >
        <thead>
          <tr>
            <th scope="col">Permit Type</th>
            <th scope="col">Start Date</th>
            <th scope="col">End Date</th>
            <th scope="col">Remove</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="subPass in this.subpasses"
            :key="subPass.id"
            :class="{
              excluded: !isDateIncluded(subPass.type, subPass.startDate)
            }"
          >
            <td>
              <font-awesome-icon
                icon="sun"
                class="hidden-xs"
                v-if="subPass.type == 'Day'"
              />
              <font-awesome-icon
                icon="moon"
                class="hidden-xs"
                v-if="subPass.type != 'Day'"
              />
              {{ subPass.type }}
            </td>
            <td>{{ subPass.startDate | formatDate }}</td>
            <td>{{ subPass.endDate | formatDate }}</td>
            <td>
              <button
                type="button"
                class="btn btn-sm btn-primary"
                v-on:click="toggleSubpass(subPass)"
              >
                {{
                  !isDateIncluded(subPass.type, subPass.startDate)
                    ? "Include"
                    : "Exclude"
                }}
              </button>
            </td>
          </tr>
        </tbody>
        <div v-if="errors['segments'] && errors['segments'] != ''">
          <tfoot>
            <tr>
              <th class="field-validation-error">{{ errors["segments"] }}</th>
            </tr>
          </tfoot>
        </div>
      </table>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSun, faMoon } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faSun, faMoon);

export default {
  components: {
    FontAwesomeIcon
  },
  props: ["startDate", "endDate", "errors"],
  data() {
    return {
      days: [],
      nights: [],
      includeOvernight: true
    };
  },
  watch: {
    startDate() {
      this.refreshSubpassList();
    },
    endDate() {
      this.refreshSubpassList();
    }
  },
  computed: {
    subpasses() {
      let passes = [];
      let start = moment(this.startDate, "MM/DD/YYYY");

      for (var i = 0; i < this.numberOfDays; i++) {
        let dayPass = {
          id: "day" + i,
          type: "Day",
          startDate: moment(start)
            .add(i, "d")
            .format("MM/DD/YYYY"),
          endDate: moment(start)
            .add(i, "d")
            .format("MM/DD/YYYY")
        };
        passes.push(dayPass);
        if (this.includeOvernight && i < this.numberOfDays - 1) {
          let nightPass = {
            id: "night" + i,
            type: "Night",
            startDate: moment(start)
              .add(i, "d")
              .format("MM/DD/YYYY"),
            endDate: moment(start)
              .add(i + 1, "d")
              .format("MM/DD/YYYY")
          };
          passes.push(nightPass);
        }
      }
      return passes;
    },
    numberOfDays() {
      if (!this.startDate || !this.endDate) {
        return 0;
      }
      let start = moment(this.startDate, "MM/DD/YYYY");

      let end = moment(this.endDate, "MM/DD/YYYY");
      let numDays = end.diff(start, "d") + 1;

      return numDays;
    }
  },
  methods: {
    isDateIncluded(type, startDate) {
      if (type == "Day") {
        if (this.days.includes(startDate)) {
          return true;
        }
        return false;
      }
      if (type == "Night") {
        if (this.nights.includes(startDate)) {
          return true;
        }
        return false;
      }
    },
    toggleSubpass(subPass) {
      if (subPass.type == "Day") {
        if (this.isDateIncluded(subPass.type, subPass.startDate)) {
          this.days = this.days.filter(n => {
            return n != subPass.startDate;
          });
        } else {
          this.days.push(subPass.startDate);
        }
        this.daysUpdated();
      }
      if (subPass.type == "Night") {
        if (this.isDateIncluded(subPass.type, subPass.startDate)) {
          this.nights = this.nights.filter(n => {
            return n != subPass.startDate;
          });
        } else {
          this.nights.push(subPass.startDate);
        }
        this.nightsUpdated();
      }
    },
    refreshSubpassList() {
      let numDays = this.numberOfDays;
      this.days = [];
      this.nights = [];
      for (let i = 0; i < numDays; i++) {
        if (numDays == 1 || i < numDays - 1) {
          let day = moment(this.startDate).add(i, "d");
          this.days.push(day.format("MM/DD/YYYY"));
        }
      }
      if (this.includeOvernight) {
        for (let i = 0; i < numDays - 1; i++) {
          let day = moment(this.startDate).add(i, "d");
          this.nights.push(day.format("MM/DD/YYYY"));
        }
      }
      this.daysUpdated();
      this.nightsUpdated();
    },
    daysUpdated() {
      this.$emit("passUpdated", { name: "days", value: this.days });
    },
    nightsUpdated() {
      this.$emit("passUpdated", { name: "nights", value: this.nights });
    },
    includeOverNightChange() {
      this.refreshSubpassList();
    }
  },
  beforeMount() {
    this.refreshSubpassList();
  }
};
</script>
